export default function Cart({data}){    
    return(
        <div id="modal_aside_right" className="modal fixed-right fade" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-aside" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">سبد خرید</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row d-flex justify-content-center align-items-center h-100 p-2">
                            <div className="col py-2 px-2">
                                {data && data.data.map((item,index) => 
                                    <div className="d-flex align-items-center mb-0" key={index}>
                                        <div className="flex-shrink-0">
                                            <img src={item.image}
                                            className="img-fluid" style={{width: "150px"}} alt="Generic placeholder"/>
                                        </div>
                                        <div className="flex-grow-1 ms-3">
                                            <a href="#!" className="float-end text-black"><i className="ti-trash"></i></a>
                                            <h5 className="text-primary">{item.name}</h5>
                                            <h6 style={{color: "#9e9e9e"}}>رنگ: سفید</h6>
                                            <div className="d-flex align-items-center">
                                                <p className="fw-bold mb-0 me-5 pe-3">{item.price}</p>
                                                <div className="def-number-input number-input safari_only">
                                                    <button onClick={() => {}} className="minus"></button>
                                                    <input className="quantity fw-bold text-black" min="0" name="quantity" defaultValue="1" type="number"/>
                                                    <button onClick={() => {}} className="plus"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <hr className="mb-4" style={{height: "2px", backgroundColor: "#1266f1", opacity: 1}}/>

                                <div className="d-flex justify-content-between px-x">
                                    <p className="fw-bold">تخفیف:</p>
                                    <p className="fw-bold">۳۰۰۰۰۰</p>
                                </div>
                                <div className="d-flex justify-content-between p-2 mb-2 rounded" style={{backgroundColor: "#e1f5fe"}}>
                                    <h5 className="fw-bold mb-0">مبلغ نهایی:</h5>
                                    <h5 className="fw-bold mb-0">۱۰۰۰۰۰۰</h5>
                                </div>
                            </div>  
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="d-grid col mx-auto">
                            <button type="button" className="btn btn-success">ثبت سفارش</button>
                        </div>
                    </div>
                </div>
            </div> 
        </div> 
    )
}
